import React from 'react';
import { Select } from 'antd';

import { AssignmentFilterTypes } from '../../../features/assignment/enums';
import { workerTypesList } from 'utils/workerUtils';
import { AssignmentFilters } from 'features/assignment/AssignmentsFilter';
import { WorkerTypeEnum } from 'api/backofficeApiClient';

type Props = {
  filters: AssignmentFilters;
  onChange: (data: AssignmentFilters) => void;
};
export default function WorkerTypeFilter(props: Props) {
  const { filters, onChange } = props;

  const handleFilterChange =
    (type: AssignmentFilterTypes) => (workerTypes: WorkerTypeEnum[]) => {
      onChange({
        ...filters,
        [type]: workerTypes,
      });
    };

  return (
    <Select
      className="full-width"
      value={filters[AssignmentFilterTypes.WorkerType]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select a worker type"
      onChange={handleFilterChange(AssignmentFilterTypes.WorkerType)}
      showSearch
      data-id="workerTypeFilterField"
      filterOption
    >
      {workerTypesList.map((workerType) => (
        <Select.Option key={workerType.value} value={workerType.value || ''}>
          {workerType.label}
        </Select.Option>
      ))}
    </Select>
  );
}
